import { useEffect, useState } from "react";
import { styled } from "styled-components";
import { FiGithub, FiLinkedin } from "react-icons/fi";
import { useLocation } from "react-router-dom";

export default function FixedDetails() {
  const location = useLocation();

  const [isAtTop, setIsAtTop] = useState(true);
  const [settledPath, setSettledPath] = useState(location.pathname);
  const [transitioning, setTransitioning] = useState(false);
  const [homeDetailsVisible, setHomeDetailsVisible] = useState(() =>
    typeof window === "undefined"
      ? false
      : Boolean(window.__homeDetailsRevealStarted),
  );

  const isRoot = settledPath === "/";

  useEffect(() => {
    const hideDuringTransition = () => {
      setTransitioning(true);

      if (window.location.pathname === "/") {
        setHomeDetailsVisible(false);
      }
    };

    const showAfterTransition = () => {
      setSettledPath(window.location.pathname);
      setTransitioning(false);
    };

    const showWithHomeDetails = () => {
      setHomeDetailsVisible(true);
    };

    window.addEventListener("page-transition:start", hideDuringTransition);
    window.addEventListener("page-transition:complete", showAfterTransition);
    window.addEventListener("home-details-reveal:start", showWithHomeDetails);

    return () => {
      window.removeEventListener("page-transition:start", hideDuringTransition);
      window.removeEventListener(
        "page-transition:complete",
        showAfterTransition,
      );
      window.removeEventListener(
        "home-details-reveal:start",
        showWithHomeDetails,
      );
    };
  }, []);

  useEffect(() => {
    if (!isRoot) return;

    const handleScroll = () => {
      setIsAtTop(window.scrollY <= 0);
    };

    handleScroll();

    window.addEventListener("scroll", handleScroll, {
      passive: true,
    });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isRoot]);

  if (!isRoot || transitioning) return null;

  const hiddenClass = !isAtTop || !homeDetailsVisible ? "hide" : "";

  return (
    <>
      <MailContainer className={hiddenClass}>
        <a href="mailto:its.sivasanker@gmail.com">its.sivasanker@gmail.com</a>

        <span className="block" />
      </MailContainer>

      <LinksContainer className={hiddenClass}>
        <Profile />
        <span className="block" />
      </LinksContainer>
    </>
  );
}

const profiles = [
  {
    icon: <FiGithub />,
    path: "https://github.com/DevelopedBy-Siva",
  },
  {
    icon: <FiLinkedin />,
    path: "https://www.linkedin.com/in/sivasanker-np",
  },
];

function Profile() {
  return (
    <Container>
      {profiles.map((item) => (
        <a key={item.path} href={item.path} target="_blank" rel="noreferrer">
          {item.icon}
        </a>
      ))}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
  margin-top: 20px;

  a {
    color: #ababab;
    font-size: 22px;
    text-decoration: none;
    transition: color 0.3s ease;
  }

  a:hover {
    color: #fff;
  }

  @media (max-width: 768px) {
    a {
      font-size: 25px;
    }
  }
`;

const MailContainer = styled.div`
  position: fixed;
  right: 50px;
  bottom: 0;
  z-index: 999;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  font-family: "Poppins", sans-serif;

  opacity: 1;
  transform: translateY(0);

  transition:
    opacity 0.3s ease,
    transform 0.4s ease;

  &.hide {
    opacity: 0;
    transform: translateY(40px);
    pointer-events: none;
  }

  .block {
    width: 1px;
    height: 90px;
    background: #939393;
  }

  a {
    color: #939393;
    font-size: 13px;
    letter-spacing: 2px;
    writing-mode: vertical-lr;
    text-decoration: none;
    transition:
      color 0.3s ease,
      transform 0.3s ease;
  }

  a:hover {
    color: #fff;
    transform: translateY(-5px);
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const LinksContainer = styled.div`
  position: fixed;
  left: 50px;
  bottom: 0;
  z-index: 999;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  font-family: "Poppins", sans-serif;

  opacity: 1;
  transform: translateY(0);

  transition:
    opacity 0.3s ease,
    transform 0.4s ease;

  &.hide {
    opacity: 0;
    transform: translateY(40px);
    pointer-events: none;
  }

  .block {
    width: 1px;
    height: 90px;
    background: #939393;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;
